import ability from '@/libs/acl/ability'

// Mesa de ayuda (GLPI): solo algunos ambientes la tienen. Se activa con
// VUE_APP_HELPDESK_ENABLED=true en env.js (equivale a HELPDESK_ENABLED en el back).
export const isHelpdeskEnabled = () => {
  const value = window.__env && window.__env.VUE_APP_HELPDESK_ENABLED
  return value === true || String(value).toLowerCase() === 'true'
}

// Quita del menú el grupo de mesa de ayuda cuando el ambiente no la tiene
export const withoutHelpdeskMenu = items => (items || [])
  .filter(item => item.title !== 'helpdesk.title')
  .map(item => (item.children ? { ...item, children: withoutHelpdeskMenu(item.children) } : item))

// Ve todos los tickets: administradores (assign) o perfiles con HelpdeskTicket:see_all.
// El resto solo ve los tickets donde participa (creador o proveedor asignado).
export const canSeeAllTickets = () => ability.can('assign', 'HelpdeskTicket')
  || ability.can('see_all', 'HelpdeskTicket')
